export function trackCustomEvent(
  eventName: string,
  params: Record<string, any> = {},
) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", eventName, params);
    console.log(`Facebook Event Sent: ${eventName}`, params);
  } else {
    console.warn("Facebook Pixel not initialized.");
  }
}
